import { APIResponse } from "../types/api.types";
import { APIQuery } from "./api.base";

export const list = async (): Promise<APIResponse> => {
    return APIQuery("/invitation/list", "GET", []);
};

export const detail = async (invitationId: number, associationId?: string): Promise<APIResponse> => {
    return APIQuery("/invitation/detail", "POST", associationId ? [{ name: "X-Association-Id", value: associationId }] : [], { invitation_id: invitationId });
};

export const add = async (payload: { email: string, role: string }): Promise<APIResponse> => {
    return APIQuery("/invitation/add", "POST", [], payload);
};

export const revoke = async (token: string): Promise<APIResponse> => {
    return APIQuery("/invitation/revoke", "POST",[], { token });
};

export const validateToken = async (token: string): Promise<APIResponse> => {
    return APIQuery("/invitation/validate-token", "POST", [], { token });
};

export const resend = async (token: string): Promise<APIResponse> => {
    return APIQuery("/invitation/resend", "POST", [], { token });
};
